<template>
    <div>
        <Form :label-width="120" ref="form" class="margin-15 clearfix">
            <FormItem :label="$t('erp.b2border.confirm_type',{defaultValue:'确认类型'})">
                <RadioGroup v-model="type">
                    <Radio label='0'>{{$t('erp.b2border.just_confirm',{defaultValue:'仅确认'})}}</Radio>
                    <Radio label='1'>{{$t('erp.b2border.confirm_pushwarehouse',{defaultValue:'确认并推送云仓'})}} </Radio>
                    <div style="margin-left: 117px"><span class="color-error">{{$t('erp.b2border.pushorder_tip',{defaultValue:'(只有云仓发货的订单才可以选择)'})}}</span></div>
                </RadioGroup>
            </FormItem>
            <FormItem :label="$t('global.common.notes',{defaultValue:'备注'})">
                <vTextarea v-model="remark" style="width:80%"></vTextarea>
            </FormItem>
        </Form>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.datepicker.confirm',{defaultValue:'确认'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.cancel',{defaultValue:'取消'})}}</vButton>
        </div>
    </div>
</template>
<script>

import { HttpOrderConfirm } from "@/service/boss/b2border";
export default {
    props:['activeids'],
    data(){
        return {
            type:'0',
            remark:"",
        }
    },
    methods:{
        submit(){
            HttpOrderConfirm({
                orderId:this.activeids,
                confirmType:this.type,
                remark:this.remark,
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
                this.$emit('on-update')
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>